exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-formula-switch .formula-control[data-v-fc4fb488]{width:100%;font-size:.875rem;line-height:1.5}", ""]);

// exports
